// extracted by mini-css-extract-plugin
module.exports = {"list":"_15549","item":"_17419","info":"_13349","avatar":"_5160","des":"_1510","name":"_878","degree":"_4073","star":"_4478","text":"_6107"};